import doc                    from 'decorators/doc';
import model                    from 'decorators/model';
import { Blamable }           from 'helpers/traits';
import { Timestampable }      from 'helpers/traits';
import InvoicePrivateApiModel from '../../abstracts/InvoicePrivateApiModel';

@model.staticLabel('Mode de facturation')
@model.urnResource('billing_frequency')
@doc.path('/billing_frequencies/{?id}')
export default class BillingFrequencyModel extends Blamable(Timestampable(InvoicePrivateApiModel)) {
	public _filters: ModelFiltersExtended<{
		'reference': InvoiceBillingFrequencyReference;
	}> = {};

	public _sorts: ModelSortsExtended<{
		'id': string;
		'label': string;
	}> = {};

	@doc.string declare description: string;
	@doc.string declare label: string;
	@doc.string declare reference: InvoiceBillingFrequencyReference;
}